import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=c5805f3c"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5805f3c')) {
      api.createRecord('c5805f3c', component.options)
    } else {
      api.reload('c5805f3c', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=c5805f3c", function () {
      api.rerender('c5805f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/navigation.vue"
export default component.exports